module.exports = __webpack_public_path__ + "761d69be94ae7a8006767510822bb942.svg";